'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'diamond-half-stroke';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M256 67.9L444.1 256 256 444.1l0-376.2z', 'M33.9 289.9L0 256l33.9-33.9L222.1 33.9 256 0l33.9 33.9L478.1 222.1 512 256l-33.9 33.9L289.9 478.1 256 512l-33.9-33.9L33.9 289.9zM256 67.9l0 376.2L444.1 256 256 67.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;